import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import CSSModules from 'react-css-modules';
import style from './pagination.scss';

@CSSModules(style)
export default class Pagination extends Component {
  static defaultProps = {
    value: 0,
    recordsPerPage: 25
  };

  onChange({ selected }) {
    if (this.props.onChange) this.props.onChange(selected + 1);
  }

  render() {
    const { value, totalRecords, recordsPerPage } = this.props;
    const totalPages = Math.ceil(totalRecords / recordsPerPage);

    return (
      <div styleName="root">
        <ReactPaginate
          nextLabel=">"
          previousLabel="<"
          clickCallback={::this.onChange}
          forceSelected={value - 1}
          pageCount={totalPages}
          {...this.props}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/pagination.js